import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { GlobalMessageService, GlobalMessageType, TranslationService } from '@spartacus/core';
import { RegisterService } from 'src/app/services/feature/register.service';
import { DemoRegistrationService } from 'src/app/services/feature/kb-demo-registration/demo-registration.service';
import { ViewportScroller } from '@angular/common';
import { Breakpoints, BreakpointObserver } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';
import { DemoRegistrationFormService } from '../services/demo-registration-form.service';
import { MatDialog } from '@angular/material/dialog';
import { VehicalPopupComponent } from '../vehical-popup/vehical-popup.component';
import { WaierpopupComponent } from '../waierpopup/waierpopup.component';
import { Router } from '@angular/router';
@Component({
  selector: 'app-kb-demo-registration-form',
  templateUrl: './kb-demo-registration-form.component.html',
  styleUrl: './kb-demo-registration-form.component.scss',
  standalone: false
})
export class KbDemoRegistrationFormComponent implements OnInit, OnDestroy {
  demoRegistrationForm: FormGroup;

  options: any[] = [];

  isOtherSelected: boolean = false;
  demoRoleCOdesToSendDemo: string[] = [];
  demoRoleCOdesToSendDemoRegister: string[] = [];

  backendIndustryRoleCodes: string[] = [];

  submitted = false;
  formSubmitted = false;

  accessRequestsWSList: any;
  countriesWSList: any;
  stateList: any;
  token: string | undefined;
  captchaResolved: boolean = false;

  isUserAlreadyRegistered: any;
  showVechicalError: boolean = false;

  pageFieldData: any;
  pageFieldData$ = this.registerService.getRegisterPageFields();

  demoPageData: any;
  subscription = new Subscription();
  demoDataTraining: any[];
  DataRecieved: boolean = false;
  demoWavierAcceptedOrNot: boolean[] = [];
  isMobile: any;
  selectedItemIndex: number;
  private timeout?: ReturnType<typeof setTimeout> | null = null;// Store the timeout ID
  showVehicleTypes = false;
  constructor(
    private registerService: RegisterService,
    private cdr: ChangeDetectorRef,
    private globalMessageService: GlobalMessageService,
    private fb: FormBuilder,
    private demoregistrationservice: DemoRegistrationService,
    private viewportScroller: ViewportScroller,
    private translationService: TranslationService,
    private breadcrumbDataService: DemoRegistrationFormService,
    private dialog: MatDialog,
    private BreakpointObserver: BreakpointObserver,
    private router: Router
  ) {
    this.token = undefined;
    this.subscription.add(this.BreakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small])
      .subscribe(result => {
        this.isMobile = result.matches;
      }));
  }

  initializeForm() {
    const industryRolesArray = this.demoPageData?.industryRolesWSList?.map(() => this.fb.control('')) || [];
    this.demoRegistrationForm = this.fb.group({
      industryRoleCodes: this.fb.array(industryRolesArray),
      emailAddress: ['', [Validators.email, Validators.required]],
      confirmemailAddress: ['', [Validators.email, Validators.required]],
      titleCode: ['', [Validators.required]],
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      demoIndustryRoleCode: [''],
      demoRoleCode: this.fb.array(this.options.map((option) => new FormControl(option.isChecked))),
      otherOptions: [''],

      companyName: ['', [Validators.required]],
      companyPhoneNumber: [''],
      PrivateDemo: [''],
      companyStreet: [''],
      companyStreetNumber: [''],
      companyAddressTwo: [''],
      companyCity: [''],
      companyZip: [''],
      companyCountryCode: [''],
      companyStateCode: [''],

      termsAccepted: [{ value: false, disabled: true }, [Validators.required]],
      recaptcha: ['', [Validators.required]],
    },
      {
        validators: this.emailMatchValidator(
          'emailAddress',
          'confirmemailAddress'
        ),
      }
    );
  }

  async ngOnInit() {
    this.subscription.add(
      this.registerService.getRegisterPageFields().subscribe((data) => {
        this.pageFieldData = data;
        this.countriesWSList = this.pageFieldData.countriesWSList;
        this.cdr.detectChanges();
      }));

    this.subscription.add(
      this.breadcrumbDataService.getFormBreadcrumb().subscribe((() => {
      })));

    await this.loadFormData();
    this.initializeForm();

    this.demoRegistrationForm.get('emailAddress')?.valueChanges.subscribe(() => {
      this.demoRegistrationForm.get('confirmemailAddress')?.updateValueAndValidity();
    });
  }

  private async loadFormData() {
    try {
      const response: any = await this.demoregistrationservice.getFormDataInitial().toPromise();
      this.demoPageData = response;
      this.options = response.demoCustomerTypeWSList.map(item => ({
        code: item.code,
        name: item.name,
        disabled: false,
        isChecked: false,
      }));
    }
    catch (error) {
    }
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    if (this.timeout) {
      clearTimeout(this.timeout);
    }

  }

  get industryRoleCodes(): FormArray {
    return this.demoRegistrationForm.get('industryRoleCodes') as FormArray
  }

  onOtherCompanyInformationsChnage(industryRoleCode: any, other: any) {

    this.demoRegistrationForm
      .get('demoIndustryRoleCode')
      ?.setValue(industryRoleCode);

    this.initCheckbox();
    this.industryRoleCodes.clear();
    this.industryRoleCodes.push(new FormControl(industryRoleCode));
    this.showVehicleTypes = industryRoleCode === 'DEALER_OEM';
    if (industryRoleCode === 'DISTRIBUTER' || industryRoleCode === 'OTHER') {
      this.options.forEach((option, i) => {
        const FormArray = this.demoRoleCode as FormArray;
        if (option.code !== 'OTHER') {
          FormArray.at(i).disable();
        }
        else {
          FormArray.at(i).patchValue(true);
          this.onMultiSlectOptionChange('OTHER', true, i, true);
        }
      });
    }
    this.cdr.detectChanges();
  }

  initCheckbox() {
    const FormArray = this.demoRoleCode as FormArray;
    FormArray.controls.forEach((element, i) => {
      FormArray.at(i).enable();
      element.patchValue(false);
    });
    this.isOtherSelected = false;
  }

  get demoRoleCode(): FormArray {
    return this.demoRegistrationForm.get('demoRoleCode') as FormArray
  }

  // getDemoFormControl(index: number) {
  //   return this.demoRoleCode.at(index) as FormControl;
  // }
  getDemoFormControl(index: number): FormControl {
    return (this.demoRegistrationForm.get('demoRoleCode') as FormArray).at(index) as FormControl;
  }

  onMultiSlectOptionChange(optionName: string, isChecked: any, ind: number, fromTs: boolean) {
    if (!fromTs) {
      isChecked = isChecked.checked
      if (!isChecked) {
        if (this.industryRoleCodes.value.includes('FLEET') || this.industryRoleCodes.value.includes('OEM') || this.industryRoleCodes.value.includes('DEALER')) {
          this.options.forEach((option, i) => {
            const FormArray = this.demoRoleCode as FormArray;
            FormArray.at(i).enable();
          });
        }
      }
    }
    const FormArray = this.demoRoleCode as FormArray;
    this.isDealerOrOEMCond(FormArray, optionName, isChecked);

    const index = this.options.findIndex(opt => opt.code === optionName);
    this.isChecked(isChecked, index, FormArray);
    const indexOther = this.options.findIndex(opt => opt.code === 'OTHER');
    if (optionName === 'OTHER' && indexOther !== -1 && isChecked) {
      this.isOtherSelected = true;

      this.demoRegistrationForm.get('otherOptions')?.reset();
      this.demoRegistrationForm.get('otherOptions')?.updateValueAndValidity();
    }
    else if (optionName === 'OTHER' && indexOther !== -1 && !isChecked) {
      this.isOtherSelected = false;

      this.demoRegistrationForm.get('otherOptions')?.updateValueAndValidity();
    }
  }

  isChecked(isChecked, index, FormArray) {
    if (isChecked) {
      if (index !== -1) {
        FormArray.at(index).patchValue(true);
      }
    }
    else {
      if (index !== -1) {
        FormArray.at(index).patchValue(false);
      }
    }

  }

  isDealerOrOEMCond(FormArray, optionName, isChecked) {
    const roleValues = this.industryRoleCodes.value;
    const isDealerOrOEM = roleValues.includes('DEALER') || roleValues.includes('OEM');
    if (isDealerOrOEM) {
      FormArray.controls.forEach((control, i) => {
        const option = this.options[i];
        if (option.code === optionName && isChecked) {
          control.enable();
          control.patchValue(true);
        }
        else {
          control.patchValue(false);
          if (isChecked) {
            FormArray.at(i).disable();
          }
          else {
            FormArray.at(i).enable();
          }
        }
      });
    }
  }
  onSubmit() {
    this.submitted = true;
    this.demoRoleCOdesToSendDemo = [];
    this.demoRoleCOdesToSendDemoRegister = [];

    const FormArray = this.demoRoleCode as FormArray;
    if (this.isFleetOrOther()) {
      this.demoRoleCOdesToSendDemo = this.options.map(opt => opt.code);
      this.demoRoleCOdesToSendDemoRegister = [...this.demoRoleCOdesToSendDemo];
    }
    else {
      FormArray.controls.forEach((control, i) => {
        if (control.getRawValue() === true) {
          const code = this.options[i].code;
          this.demoRoleCOdesToSendDemoRegister.push(code);
          this.demoRoleCOdesToSendDemo.push(code);
        }
      });
    }

    const formData = {
      ...this.demoRegistrationForm.value,
      // ✅ EXACT REQUIREMENT
      industryRoleCodes: this.backendIndustryRoleCodes,
      demoCustomerTypeCodes: this.demoRoleCOdesToSendDemoRegister
    };

    console.log(formData);

    if (this.demoRegistrationForm.valid) {
      this.subscription.add(this.demoregistrationservice.submitDemoDataData(formData).subscribe((response: any) => {
        if (response.message) {
          // this.translationService.translate(response.message).subscribe((text) => {
          //   this.globalMessageService.add(text, GlobalMessageType.MSG_TYPE_CONFIRMATION);
          // })
          this.viewportScroller.scrollToPosition([0, 50]);
          for (const control in this.demoRegistrationForm.controls) {
            this.demoRegistrationForm.controls[control].disable();
          }
          this.formSubmitted = true;
          const DisplayTableFormData = {
            demoCustomerTypeCodes: this.demoRoleCOdesToSendDemo,
            emailAddress: this.demoRegistrationForm.get('emailAddress').value,
            privateDemoCode: this.demoRegistrationForm.get('PrivateDemo').value
          }
          this.subscription.add(this.demoregistrationservice.displayTrainingData(DisplayTableFormData).subscribe((data: any) => {
            this.demoDataTraining = data.demosData;
            this.demoWavierAcceptedOrNot = Array(this.demoDataTraining.length).fill(false);
            this.DataRecieved = true;
          }));
        }
      }));
    }
    else {
      this.demoRegistrationForm.markAllAsTouched();
      if (this.demoRoleCOdesToSendDemoRegister.length === 0) {
        this.showVechicalError = true
      }
      this.formSubmitted = false;
      this.viewportScroller.scrollToPosition([0, 50]);
    }
  }


  onCountryChange(ev: any, stateCode?: string) {
    if (ev?.target?.value) {
      this.subscription.add(this.registerService.getRegions(ev.target.value).subscribe((data) => {
        this.stateList = data;
      }));
    }
    else {
      this.subscription.add(this.registerService.getRegions(ev).subscribe((data) => {
        this.stateList = data;
        this.demoRegistrationForm.controls['companyStateCode'].patchValue(stateCode);
      }));
    }
  }
  atLeastOneSelectedValidator(): ValidatorFn {
    return (control: AbstractControl) => {
      const value = control.value || [];
      return value.length > 0 ? null : { required: true };
    };
  }
  checkCaptcha(captchaResponse: string) {
    this.captchaResolved =
      captchaResponse && captchaResponse.length > 0 ? true : false;
  }

  private isFleetOrOther(): boolean {
    const roles = this.industryRoleCodes.value || [];
    return roles.includes('FLEET') || roles.includes('OTHER');
  }

  openVehicalPopup() {
    this.dialog.open(VehicalPopupComponent, {
      width: '500px',
    });
  }
  dialogConfi: any
  openTermsAndConditionsDialog(i: any, demoCode: string) {
    if (this.isMobile) {
      this.dialogConfi = {
        height: '722px',
        maxWidth: '93vw',
        data: {
          emailAddress: this.demoRegistrationForm.get('emailAddress').value,
          demoCode: demoCode,
          firstName: this.demoRegistrationForm.get('firstName').value,
          lastName: this.demoRegistrationForm.get('lastName').value,
        }
      }
    }
    else {
      this.dialogConfi = {
        width: '60vw',
        height: '80vh',
        maxHeight: '90vh',
        panelClass: 'waiver_popup_class',
        data: {
          emailAddress: this.demoRegistrationForm.get('emailAddress').value,
          demoCode: demoCode,
          firstName: this.demoRegistrationForm.get('firstName').value,
          lastName: this.demoRegistrationForm.get('lastName').value,
        }
      };
    }
    const dialogRef = this.dialog.open(WaierpopupComponent, this.dialogConfi)
    this.subscription.add(dialogRef.afterClosed().subscribe((data) => {

      if (data && data !== 'error') {
        const payload = {
          demoCustomerTypeCodes: this.demoRoleCOdesToSendDemo,
          emailAddress: this.demoRegistrationForm?.get('emailAddress').value,
          privateDemoCode: this.demoRegistrationForm?.get('PrivateDemo').value
        };

        this.demoregistrationservice.displayTrainingData(payload).subscribe((res: any) => {
          console.log('API response:', res.demosData);

          this.demoDataTraining = [...(res.demosData || [])]; // ✅ KEY FIX
          this.demoWavierAcceptedOrNot = Array(this.demoDataTraining.length).fill(false);
          this.DataRecieved = true;

          this.cdr.detectChanges(); // ✅ ensure UI refresh

          this.viewportScroller.scrollToPosition([0, 50]);

          this.translationService.translate('common.register_success').subscribe((text) => {
            this.globalMessageService.add(text, GlobalMessageType.MSG_TYPE_CONFIRMATION);
          });
        });
      }
    }));
  }

  checkExistingEmailAddress() {
    if (this.demoRegistrationForm.controls['emailAddress'].value) {
      this.subscription.add(this.registerService
        .checkExistingEmail(this.demoRegistrationForm.controls['emailAddress'].value)
        .subscribe((res: any) => {

          this.isUserAlreadyRegistered = res?.message ? res?.message : '';
          if (this.isUserAlreadyRegistered) {
            this.subscription.add(this.demoregistrationservice.getCustomerData(this.demoRegistrationForm.controls['emailAddress'].value).subscribe((response: any) => {
              this.demoRegistrationForm.controls['confirmemailAddress'].patchValue(response.emailAddress);
              this.demoRegistrationForm.controls['titleCode'].patchValue(response.titleCode);
              this.demoRegistrationForm.controls['firstName'].patchValue(response.firstName);
              this.demoRegistrationForm.controls['lastName'].patchValue(response.lastName);

              this.demoRegistrationForm.controls['companyName'].patchValue(response.companyName);
              this.demoRegistrationForm.controls['companyPhoneNumber'].patchValue(response.companyPhoneNumber);

              this.demoRegistrationForm.controls['companyStreet'].patchValue(response.companyStreet);
              this.demoRegistrationForm.controls['companyStreetNumber'].patchValue(response.companyStreetNumber);
              this.demoRegistrationForm.controls['companyCity'].patchValue(response.companyCity);
              this.demoRegistrationForm.controls['companyZip'].patchValue(response.companyZip);

              this.demoRegistrationForm.controls['companyAddressTwo'].patchValue(response.companyAddressTwo);


              this.demoRegistrationForm.controls['companyCountryCode'].patchValue(response.companyCountryCode);
              this.onCountryChange(response.companyCountryCode, response.companyStateCode);



              if (response.industryRoleCodes?.length) {
                this.backendIndustryRoleCodes = [...response.industryRoleCodes];
                /*  this.demoRegistrationForm
                   .get('demoIndustryRoleCode')
                   ?.setValue(response.industryRoleCodes[0]); */
              } else {
                this.backendIndustryRoleCodes = [];
              }

              if (response.demoIndustryRoleCode) {
                const backendRole = response.demoIndustryRoleCode;
                this.showVehicleTypes = response.demoIndustryRoleCode === 'DEALER_OEM';
                // ✅ clear existing values
                this.industryRoleCodes.controls.forEach(ctrl => {
                  ctrl.setValue('');
                });

                // ✅ set backend role to matching index
                const index = this.demoPageData.industryRolesWSList
                  ?.findIndex(r => r.code === backendRole);

                if (index !== -1) {
                  this.industryRoleCodes.at(index).setValue(backendRole);
                }

                // ✅ keep single value separately if you need it elsewhere
                this.demoRegistrationForm
                  .get('demoIndustryRoleCode')
                  ?.setValue(backendRole);
              }


              if (response.demoCustomerTypeCodes?.length) {
                this.options.forEach((option, index) => {
                  if (response.demoCustomerTypeCodes?.includes(option.code)) {
                    this.demoRoleCode.at(index).setValue(true)
                  }
                })
              }
              if (this.industryRoleCodes.value.includes('DISTRIBUTER')) {
                this.options.forEach((option, i) => {
                  const FormArray = this.demoRoleCode as FormArray;
                  if (option.code !== 'OTHER') {
                    FormArray.at(i).disable();
                  }
                  else {
                    FormArray.at(i).patchValue(true);
                    this.onMultiSlectOptionChange('OTHER', true, i, true);
                  }
                });
              }
            }));
          }
          this.cdr.detectChanges();
        }));
    }
  }

  getConvertedDate(dateString: string) {
    const cleanedDateString = dateString.replace(/\b[A-Z]{3,}\b/g, '')
    const date = new Date(cleanedDateString.trim());
    if (isNaN(date.getTime())) {
      return 'Invalid Date';
    }

    return date.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  }
  popupOpendemoCode: boolean = false;

  openPopupDemoCode() {
    this.popupOpendemoCode = true;
  }

  closePopupCompanyName() {
    this.popupOpendemoCode = false;
  }
  emailMatchValidator(emailKey: string, confirmEmailKey: string): ValidatorFn {
    return (form: AbstractControl): ValidationErrors | null => {
      const email = form.get(emailKey);
      const confirmEmail = form.get(confirmEmailKey);

      if (!email || !confirmEmail) {
        return null;
      }

      // ✅ DO NOT validate on page load
      if (!email.value?.toLowerCase() || !confirmEmail.value?.toLowerCase()) {
        const errors = confirmEmail.errors;
        if (errors) {
          delete errors['emailMismatch'];
          if (Object.keys(errors).length === 0) {
            confirmEmail.setErrors(null);
          }
        }
        return null;
      }

      const errors = confirmEmail.errors || {};

      if (email.value?.toLowerCase() !== confirmEmail.value?.toLowerCase()) {
        errors['emailMismatch'] = true;
      } else {
        delete errors['emailMismatch'];
      }

      confirmEmail.setErrors(
        Object.keys(errors).length ? errors : null
      );

      return null;
    };
  }

  goBackToPrefilled() {
    // this.location.back();
    this.DataRecieved = false;
    this.demoRegistrationForm.markAllAsTouched();
    this.demoRegistrationForm.enable();
    if (this.demoRoleCOdesToSendDemoRegister.length === 0) {
      this.showVechicalError = true
    }
    this.formSubmitted = false;
    this.viewportScroller.scrollToPosition([0, 150]);
    this.cdr.detectChanges();
  }

  async goToNewRegistration() {
    this.DataRecieved = false;
    this.submitted = false;
    this.formSubmitted = false;
    this.showVechicalError = false;
    await this.loadFormData();
    this.initializeForm();
    this.viewportScroller.scrollToPosition([0, 150]);
    this.cdr.detectChanges();
  }

  goToLandingPage() {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/myDemoRegistration'])
    );

    window.open(url, '_blank');
  }

}